import { render, staticRenderFns } from "./ayuda.vue?vue&type=template&id=2e836296&scoped=true&"
import script from "./ayuda.vue?vue&type=script&lang=ts&"
export * from "./ayuda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e836296",
  null
  
)

export default component.exports